export const CREDENTIAL_TYPE_PASSCODE_CARD = 1;
export const CREDENTIAL_TYPE_PASSCODE = 2;
